(function () {
  if (window.__clerkPowerstepInitialized) return;
  window.__clerkPowerstepInitialized = true;

  function initializeClerkPowerstep() {
    const powerstep = document.getElementById('clerk_powerstep');

    if (!powerstep) {
      console.error('[Clerk PowerStep] #clerk_powerstep was not found.');
      return;
    }

    const drawerSelector = '#sidebar-cart';
    const drawerTriggerSelector =
      '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]';

    let pendingNativeProduct = null;

    function getProductFromClerkButton(button) {
      const card =
        button.closest('[data-default-variant-id]') ||
        button.closest('[data-product-id]') ||
        button.closest('[data-clerk-product-id]');

      const image = card?.querySelector('img');

      const title =
        card?.querySelector(
          '.powerstep-product-title, .clerk-product-title, [data-product-title]'
        )?.textContent?.trim() ||
        card?.querySelector('a[href*="/products/"]')?.textContent?.trim() ||
        '';

      return {
        productId:
          button.dataset.clerkProductId ||
          card?.dataset.productId ||
          card?.dataset.clerkProductId ||
          '',
        variantId:
          button.dataset.clerkVariantId ||
          card?.dataset.defaultVariantId ||
          '',
        title,
        imageUrl: image?.currentSrc || image?.src || ''
      };
    }

    function getCurrentProductFromPage(button) {
      const form = button.closest('form');

      const variantInput =
        form?.querySelector('[name="id"]') ||
        document.querySelector('form[action*="/cart/add"] [name="id"]');

      const recommendations = powerstep.querySelector(
        '.clerk-powerstep-recommendations'
      );

      const productIdFromRecommendations =
        recommendations?.dataset.products?.match(/\d+/)?.[0] || '';

      const titleFromMarkup = powerstep.querySelector(
        '.clerk-powerstep-product-title, .clerk_powerstep_header h2 b u'
      )?.textContent?.trim() || '';

      const imageFromMarkup = powerstep.querySelector(
        '.clerk-powerstep-product-image, .clerk_powerstep_image img'
      )?.src || '';

      return {
        productId:
          powerstep.dataset.productId ||
          productIdFromRecommendations ||
          '',
        variantId: variantInput?.value || '',
        title: powerstep.dataset.productTitle || titleFromMarkup,
        imageUrl: powerstep.dataset.productImage || imageFromMarkup
      };
    }

    function openPowerstep(product) {
      if (!product?.productId) {
        console.error('[Clerk PowerStep] Product ID is missing.', product);
        return;
      }

      const titleElement = powerstep.querySelector(
        '.clerk-powerstep-product-title, .clerk_powerstep_header h2 b u'
      );

      const imageElement = powerstep.querySelector(
        '.clerk-powerstep-product-image, .clerk_powerstep_image img'
      );

      const recommendations = powerstep.querySelector(
        '.clerk-powerstep-recommendations'
      );

      if (titleElement) {
        titleElement.textContent = product.title || '';
      }

      if (imageElement) {
        imageElement.src = product.imageUrl || '';
        imageElement.alt = product.title || '';
      }

      if (recommendations) {
        recommendations.dataset.products = `[${product.productId}]`;
      }

      powerstep.style.display = 'block';
      powerstep.style.padding = '5px 15px';
      powerstep.setAttribute('aria-hidden', 'false');
      powerstep.classList.add('animate_top');

      if (typeof Clerk === 'function') {
        Clerk('content', '.clerk-powerstep-recommendations');
      }

      setTimeout(function () {
        const productPage =
          document.querySelector('[data-section-id="product-template"] > div') ||
          document.querySelector('.product-section > section');

        const header = document.querySelector('header');

        productPage?.addEventListener('click', closePowerstep);
        header?.addEventListener('click', closePowerstep);
      }, 500);
    }

    function closePowerstep() {
      powerstep.style.display = 'none';
      powerstep.setAttribute('aria-hidden', 'true');
      powerstep.classList.remove('animate_top');
    }

    window.open_powerstep = openPowerstep;
    window.close_powerstep = closePowerstep;

    async function refreshCartDrawer() {
      const drawer = document.querySelector(drawerSelector);

      try {
        // This is the same endpoint used by the theme's native cart handler.
        // Clerk emits cart:refresh only after its /cart/add.js request has
        // completed, so the new line item is committed before this request.
        const response = await fetch(
          `/cart?view=drawer&timestamp=${Date.now()}`,
          {
            credentials: 'same-origin',
            method: 'GET',
            cache: 'no-store'
          }
        );

        if (!response.ok) {
          throw new Error(`Cart drawer request failed with HTTP ${response.status}`);
        }

        const html = await response.text();
        const renderedCart = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.Cart');
        const currentCart = drawer?.querySelector('.Cart');

        if (!renderedCart || !currentCart) {
          throw new Error('The refreshed response did not contain a .Cart element.');
        }

        // Preserve #sidebar-cart itself. The theme's Drawer instance and its
        // delegated click handlers are attached to that node.
        currentCart.parentNode.replaceChild(renderedCart, currentCart);
      } catch (error) {
        console.error('[Clerk PowerStep] Cart drawer refresh failed.', error);
      }

      // Use the theme's own drawer trigger after the contents are replaced.
      // This keeps its normal animation, overlay and aria state behaviour.
      const currentDrawer = document.querySelector(drawerSelector);

      if (
        !currentDrawer ||
        currentDrawer.getAttribute('aria-hidden') !== 'false'
      ) {
        document.querySelector(drawerTriggerSelector)?.click();
      }
    }

    function handleClerkAddCompleted(button, product) {
      const addResult = refreshCartDrawer();

      if (!button.closest('#clerk_powerstep')) {
        Promise.resolve(addResult).then(function () {
          openPowerstep(product);
        });
      }
    }

    function watchForClerkAdd(button) {
      const product = getProductFromClerkButton(button);

      if (!product.productId) {
        console.error('[Clerk PowerStep] Clerk product ID is missing.', product);
        return;
      }

      let completed = false;
      let observer;

      const finish = function () {
        if (completed) return;

        completed = true;
        observer?.disconnect();
        document.documentElement.removeEventListener(
          'cart:refresh',
          finish
        );

        handleClerkAddCompleted(button, product);
      };

      const countElement = document.querySelector('.Cart__ItemCount');

      if (countElement) {
        observer = new MutationObserver(finish);
        observer.observe(countElement, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }

      document.documentElement.addEventListener(
        'cart:refresh',
        finish,
        { once: true }
      );

      // Fallback for Clerk implementations that update the cart without
      // changing the header count or dispatching cart:refresh.
      setTimeout(finish, 3000);
    }

    // Listen only to actual Clerk add-to-cart controls.
    document.addEventListener(
      'click',
      function (event) {
        const target = event.target;

        if (!(target instanceof Element)) return;

        const button = target.closest(
          'button.clerk-add-to-cart-btn,' +
            'button.powerstep-add-to-cart-btn,' +
            'a.clerk-add-to-cart-btn,' +
            '[role="button"].clerk-add-to-cart-btn'
        );

        if (!button) return;

        // Do not preventDefault or stopPropagation. Clerk's existing
        // addToClerkCart handler must perform the actual cart add.
        watchForClerkAdd(button);
      },
      true
    );

    // Preserve the working native product-page flow.
    function bindNativeProductAdd() {
      const buyButton = document.querySelector('[data-add-to-cart]') ||
        document.querySelector('.ProductForm__AddToCart');

      if (!buyButton) return;

      buyButton.addEventListener('click', function () {
        pendingNativeProduct = getCurrentProductFromPage(buyButton);
        openPowerstep(pendingNativeProduct);
      });
    }

    bindNativeProductAdd();

    // If the native theme dispatches this event, clear the pending state.
    document.documentElement.addEventListener('cart:refresh', function () {
      pendingNativeProduct = null;
    });

    document.addEventListener('click', function (event) {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const actionElement = target.closest('[data-powerstep-action]');

      if (!actionElement) return;

      const action = actionElement.dataset.powerstepAction;

      if (action === 'close') {
        closePowerstep();
      }

      if (action === 'checkout') {
        window.location.href = powerstep.dataset.cartUrl;
      }
    });

    // Do not define or overwrite addToClerkCart here. Clerk's own handler
    // must remain responsible for performing the actual Clerk cart add.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeClerkPowerstep);
  } else {
    initializeClerkPowerstep();
  }
})();
